// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b164dd6","732":"488b3f89","977":"cc36908b"}[chunkId] + ".chunk.js";
};